import { createFileRoute, Link } from '@tanstack/react-router';
import { DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE, PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { ActionTileGrid, type ActionTileGridTile } from '@interxfi/design-system/components/action-tile/grid/action-tile-grid';
import { BetaNxtVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/beta-nxt/beta-nxt-vendor-illustration';
import { DtccVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/dtcc/dtcc-vendor-illustration';
import { IceVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/ice/ice-vendor-illustration';
import { IncreaseVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/increase/increase-vendor-illustration';
import { JaneStreetVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/jane-street/jane-street-vendor-illustration';
import { JpmVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/jpm/jpm-vendor-illustration';
import { PlaidVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/plaid/plaid-vendor-illustration';
import { QuoteMediaVendorIllustration } from '@interxfi/design-system/icons/vendor-illustration/quote-media/quote-media-vendor-illustration';
import { DTC_FILE_REQUEST_BASE_PATH } from '../../../../../../../features/dtc/files/v1/dtc-file-request-routing';
import { PROXYVOTE_JOB_BASE_PATH } from '../../../../../../../features/proxyvote/job/proxyvote-job-routing';
import { ICE_GSM_INSTRUMENT_BASE_PATH } from '../../../../../../../features/vendor/ice/global-security-master/instrument/ice-gsm-instrument-routing';
import { INCREASE_ACH_BASE_PATH } from '../../../../../../../features/vendor/increase/ach/increase-ach-routing';
import { JANE_STREET_PFOF_JOB_BASE_PATH } from '../../../../../../../features/vendor/jane-street/pfof/job/jane-street-pfof-job-routing';
import { JPMAM_ORDER_BASE_PATH } from '../../../../../../../features/vendor/jpmam/order/jpmam-order-routing';
import { PLAID_PROCESSOR_TOKEN_BASE_PATH } from '../../../../../../../features/vendor/plaid/processor-token/plaid-processor-token-routing';
import { QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH } from '../../../../../../../features/vendor/quotemedia/eod-price/job/quotemedia-eod-price-job-routing';
import { getPageHead } from '../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/')({
  head: () => getPageHead('Vendors'),
  component: ClearingVendorIndex,
});

const routes = [
  {
    illustration: <IncreaseVendorIllustration />,
    title: 'Increase',
    subtitle: "Adapter from Interchange's gRPC ecosystem to Increase's HTTP API",
    to: INCREASE_ACH_BASE_PATH,
    tone: 'custom',
  },
  {
    illustration: <QuoteMediaVendorIllustration />,
    title: 'QuoteMedia',
    subtitle: 'End of day asset quotes and S&P 500 constituent lists',
    to: QUOTEMEDIA_EOD_PRICE_JOB_BASE_PATH,
    tone: 'custom',
  },
  {
    illustration: <JpmVendorIllustration />,
    title: 'J.P. Morgan',
    subtitle: 'Sweeps Purchases, Redemptions, Net Orders, Jobs, and Tasks',
    to: JPMAM_ORDER_BASE_PATH,
    tone: 'custom',
  },
  {
    illustration: <IceVendorIllustration />,
    title: 'Intercontinental Exchange (ICE)',
    subtitle: 'Intercontinental Exchange Instruments, Corporate Actions, Jobs, and Tasks',
    to: ICE_GSM_INSTRUMENT_BASE_PATH,
    tone: 'custom',
  },
  {
    illustration: <BetaNxtVendorIllustration />,
    title: 'BetaNXT',
    subtitle: 'Jobs and tasks for proxy voting and prospectus processing',
    to: PROXYVOTE_JOB_BASE_PATH,
    tone: 'custom',
  },
  {
    illustration: <DtccVendorIllustration />,
    title: 'DTCC',
    subtitle: 'DTC Files and File Requests',
    to: DTC_FILE_REQUEST_BASE_PATH,
    tone: 'custom',
  },
  {
    illustration: <JaneStreetVendorIllustration />,
    title: 'Jane Street',
    subtitle: 'Payment for Order Flow (PFOF) Jobs',
    to: JANE_STREET_PFOF_JOB_BASE_PATH,
    tone: 'custom',
  },
  {
    illustration: <PlaidVendorIllustration />,
    title: 'Plaid',
    subtitle: 'Processor Tokens',
    to: PLAID_PROCESSOR_TOKEN_BASE_PATH,
    tone: 'custom',
  },
] as const satisfies ActionTileGridTile[];

function ClearingVendorIndex() {
  return (
    <PageLayout gap={7} maxWidthContainer={DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE}>
      <PageLayout.Section noBorder>
        <ActionTileGrid items={routes} LinkElement={Link} />
      </PageLayout.Section>
    </PageLayout>
  );
}
